import { Injectable } from '@angular/core';
//import * as mime from 'mime-types';

@Injectable()
export class MimeTypesHelper {
    public mime: any;
    constructor() {
        // this.mime = mime;
    }
}